import { makeStyles } from '@material-ui/core/styles';

export const useIndexStyles = makeStyles(theme => ({
    pageHeader: {
        color: "#184d6a !important"
    //    borderBottom: "1px solid #eee"
    }

}));